import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8.5 6h13.5l-7 12h-13l6.5 -12","key":"svg-0"}]]

const IconBrandBandcamp = createReactComponent('outline', 'brand-bandcamp', 'BrandBandcamp', __iconNode);

export default IconBrandBandcamp;